import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import TeamMemberModal from "./TeamMemberModal";

const TeamsSection = () => {
  const [teams, setTeams] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchTeams = async () => {
    const res = await api.get("companyblog/admin/team-members/");
    setTeams(res.data);
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  const handleDelete = async (id) => {
    await api.delete(`companyblog/admin/team-members/${id}/`);
    fetchTeams();
  };

  return (
    <>
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5>Teams</h5>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          NEW TEAM
        </button>
      </div>

      <div className="card-body">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Position</th>
              <th>Social</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {teams.map((team) => (
              <tr key={team.id}>
                <td>
                  <img
                    src={team.image}
                    alt=""
                    width="60"
                    style={{ borderRadius: "6px" }}
                  />
                </td>
                <td>{team.team_name}</td>
                <td>{team.position}</td>
                <td>
                  <a href={team.social_facebook} target="_blank">FB</a>{" | "}
                  <a href={team.social_insta} target="_blank">IG</a>{" | "}
                  <a href={team.social_linkedin} target="_blank">IN</a>
                </td>
                <td>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(team.id)}
                  >
                    DELETE
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
      {showModal && (
        <TeamMemberModal
          onClose={() => setShowModal(false)}
          onSaved={fetchTeams}
        />
      )}
    </>

  );
};

export default TeamsSection;
